module.exports = __webpack_public_path__ + "static/media/downloads.c0a7f17d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/downloads.svg
// module id = 3242
// module chunks = 0